@if (isAllLoaded$ | async) {
  <app-vertical-tabs
    class="w-62.5 bg-navy-30"
    [tabs]="tabs"
    [selectTabById]="selectedTab"
    (tabChange)="tabChange($event)"
  ></app-vertical-tabs>

  @switch (selectedTab) {
    @case (SettingsTabs.Notifications) {
      <app-notifications-settings></app-notifications-settings>
    }
    @case (SettingsTabs.Legal) {
      <app-legal-settings></app-legal-settings>
    }
    @case (SettingsTabs.Automations) {
      <app-automations></app-automations>
    }
    @case (SettingsTabs.Branding) {
      <app-branding-settings></app-branding-settings>
    }
    @case (SettingsTabs.PermissionProfiles) {
      <app-permission-profiles-settings></app-permission-profiles-settings>
    }
  }
} @else {
  <div class="w-full h-full bg-navy-30">
    <app-loading-animation [width]="'270px'" [height]="'270px'"></app-loading-animation>
  </div>
}
